import React, { useState } from "react";
import { TextField } from "@material-ui/core";
import axios from "axios";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { StyledClientsEditNickname } from "../../../clients/styledClients";

const ServiceNicknameForm = ({ service, t, notification, setNotification }) => {

  const [isEdit, setIsEdit] = useState(false);
  const [currentNickname, setCurrentNickname] = useState(service.nickname);

  const save = () => {
    const newNickname = service.nickname === "" ? null : service.nickname;

    axios.put("/api/services/" + service.id, { nickname: newNickname }, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setCurrentNickname(service.nickname);
        setIsEdit(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("details.nicknameEdit.successEdit") });
      }
    }).catch(error => {
      service.nickname = currentNickname;
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <>
      <StyledClientsEditNickname>
        {isEdit ? (
          <div className="nickname-edit-form">
            <TextField
              id={`nickname.${service.id}`}
              defaultValue={service.nickname ?? ""}
              onChange={(data) => {service.nickname = data.target.value;}}
            />
            <div className="nickname-edit-form__actions">
              <button
                className="table-action"
                onClick={save}
              >
                <span className="icon-light-check" />
                {t("details.nicknameEdit.save")}
              </button>
              <button
                className="table-action table-action_danger"
                onClick={() => {
                  setIsEdit(false);
                  service.nickname = currentNickname;
                }}
              >
                <span className="icon-light-cancel" />
                {t("details.nicknameEdit.cancel")}
              </button>
            </div>
          </div>
        ) : (
          <div className="nickname-edit">
            <b>{service.nickname ? service.nickname : t("details.nicknameEdit.empty")}</b>
            <button
              className="table-action table-action_info"
              onClick={() => setIsEdit(true)}
            >
              <span className="icon-light-edit" />
              {t("details.nicknameEdit.edit")}
            </button>
          </div>
        )}
      </StyledClientsEditNickname>
    </>
  );
};

export default ServiceNicknameForm;